import Plum1 from "../../../media/magenta/plum/plum1.png";
import Iris1 from "../../../media/magenta/iris/magenta iris.png";
import Iris2 from "../../../media/magenta/iris/magenta iris (2).png";
import Lilac1 from "../../../media/magenta/lilac/lilac1.png";
import Lilac2 from "../../../media/magenta/lilac/lilac2.png";
import Plum2 from "../../../media/magenta/plum/plum2.png";

const magentaimages = [Plum1, Iris1, Lilac1, Iris2, Lilac2, Plum2];

export default magentaimages;
